import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

interface dropdowns {
  value: number;
  viewValue: string;
}

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit {

  @Input('pickerType') pickerType;

  @Input('dropdown') dropdowns: dropdowns[];

  @Input('initData') selectedValue: number;

  @Input('dropdown_label') dropdown_label: String;

  @Input('disabled') disabled: boolean;

  @Output() valueChanged: EventEmitter<number> =   new EventEmitter();

  constructor() { }

  ngOnInit() { }

  valueChange(data){
    this.selectedValue = data;
    this.valueChanged.emit(data);
  }
}